import styles from "../../store/views/ProjectForm/ProjectForm.module.sass";
import ConfigContainer from "../../store/views/ConfigMerge/ConfigContainer";
import MetadataContainer from "../../store/views/ConfigMetadata/MetadataEntry";
import React from "react";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import { arrayHasDups } from "../../utils/json";

const BuildConfigurationComponentContainer = ({ target, fileType, setter, fileTypeToEntity }) => {
    const isMappingMode = Array.isArray(fileTypeToEntity) && fileTypeToEntity.length > 0;
    const defaultObjConfig = {
        ID: 0,
        FileType: "",
        Description: "",
        Configuration: "",
        ...(isMappingMode ? { Entity: "" } : {}),
    };
    const handleConfigChange = (index, updatedConfig) => {
        const newArray = [...target];
        if (updatedConfig === null) {
            newArray.splice(index, 1);
        } else {
            newArray[index] = updatedConfig;
        }
        setter(newArray);
    };

    const showAddConfigButton = () => {
        if (Array.isArray(fileType) && fileType.length > 0) {
            return (
                <button
                    className={styles["add-button"]}
                    type="button"
                    onClick={(e) => {
                        const config = { ...defaultObjConfig };
                        config.FileType = fileType[0].name;
                        setter([...target, config]);
                    }}
                >
                    <small>{`[+] Add new configuration`}</small>
                </button>
            );
        } else {
            if (Array.isArray(target) && target.length > 0) {
                return (
                    <>
                        <br />
                        <small>{`You have already added merge configurations for all the available SAFT modules in the project.`}</small>
                    </>
                );
            }
        }
    };

    return (
        <div className={styles["flex"]} key={(fileType || []).length}>
            <div className={styles["input-field"]}>
                <div>
                    {(target || []).length ? (
                        target.map((config, index) => (
                            <ConfigContainer
                                className={styles["rule-entry"]}
                                config={config}
                                key={index}
                                index={index}
                                onChange={handleConfigChange}
                                appliesToFilter={fileType}
                                fileTypeToEntity={fileTypeToEntity}
                            />
                        ))
                    ) : (
                        <small>{`No configurations assigned`}</small>
                    )}
                </div>
                {showAddConfigButton()}
            </div>
        </div>
    );
};

const BuildMetadataConfigurationContainer = ({
    keysArray,
    valuesArray,
    keysSetter,
    valuesSetter,
    addButtonMessage,
    noMetadataConfigsMessage,
    containerTitle,
    uniqueName,
    keyErrorCheck,
    keyErrorSetter,
    dupKeyMessage,
}) => {
    const { i18n } = useGlobalValue();
    const handleMetadataChange = (index, updateMetadata, inputName = undefined) => {
        const newKeysArray = [...keysArray];
        const newValuesArray = [...valuesArray];
        if (updateMetadata === null) {
            newKeysArray.splice(index, 1);
            newValuesArray.splice(index, 1);
        }
        if (inputName && inputName === "keyArray") {
            newKeysArray[index] = updateMetadata;
        } else if (inputName && inputName === "valueArray") {
            newValuesArray[index] = updateMetadata;
        }
        keysSetter([...newKeysArray]);
        valuesSetter([...newValuesArray]);
        if (arrayHasDups(newKeysArray)) {
            keyErrorSetter(true);
        } else {
            keyErrorSetter(false);
        }
    };

    const showAddMetadataButton = () => {
        if (Array.isArray(keysArray)) {
            return (
                <div>
                    <button
                        className={styles["add-button"]}
                        type="button"
                        onClick={(e) => {
                            keysSetter([...keysArray, ""]);
                            valuesSetter([...valuesArray, ""]);
                        }}
                    >
                        <small>{i18n`${addButtonMessage}`}</small>
                    </button>
                </div>
            );
        }
    };
    return (
        <div className={styles["flex"]} key={uniqueName}>
            <div className={styles["input-field"]}>
                {containerTitle && <h5 className={styles["label"]}>{i18n`${containerTitle}`}</h5>}
                {keyErrorCheck ? (
                    <div className={styles["errors-container"]}>
                        <div className={styles["error"]}>
                            <small>{i18n`${dupKeyMessage}`}</small>
                        </div>
                    </div>
                ) : null}
                <div>
                    {(keysArray || []).length ? (
                        <MetadataContainer
                            className={styles["metadata-entry"]}
                            metadataKeys={keysArray}
                            metadataValues={valuesArray}
                            onChange={handleMetadataChange}
                        />
                    ) : (
                        <small>{i18n`${noMetadataConfigsMessage}`}</small>
                    )}
                </div>
                {showAddMetadataButton()}
            </div>
        </div>
    );
};

export { BuildConfigurationComponentContainer, BuildMetadataConfigurationContainer };
